import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import InputField from '../../inputField';
import ActionButton from '../../actionButton';
import { ACTION_BUTTON_TYPES } from '../../actionButton/config';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'minMax(0, 346px)',
    gridColumnGap: 24,
  },
  hasError: {
    marginBottom: spacing(1),
  },
  field: {
    position: 'relative',
    marginBottom: spacing(6),
  },
  errorMessage: {
    position: 'absolute',
    bottom: -20,
  },
  fieldWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  deleteButton: {
    flexShrink: 0,
    marginLeft: spacing(2),
  },
}));

const TextField = ({
  translations,
  id,
  value,
  fieldTypes,
  error = null,
  onDelete,
  onChange,
  isDisabled,
}) => {
  const classes = useStyles();
  const [textField] = fieldTypes;

  const handleChangeText = useCallback(
    (e, name) => {
      onChange({ ...value, [name]: e.target.value }, id);
    },
    [id, value, onChange]
  );

  return (
    <div className={classes.root}>
      <div
        key={textField.name}
        className={classNames(classes.field, { [classes.hasError]: error })}
      >
        <div className={classes.fieldWrapper}>
          <InputField
            customErrorClass={classes.errorMessage}
            id={textField.name}
            name={textField.name}
            type={textField.type}
            placeholder={
              translations.labels[textField.translationKey].placeholder
            }
            required={textField.required}
            value={value?.[textField.name] || ''}
            error={!!error?.[textField.name]}
            errorMessage={
              translations.validationMessages?.[error?.[textField.name]]
            }
            disabled={isDisabled}
            onChange={e => handleChangeText(e, textField.name)}
            fullWidth
          />
          <ActionButton
            className={classes.deleteButton}
            type={ACTION_BUTTON_TYPES.DELETE_FILL}
            isDisabled={isDisabled}
            onClickHandler={onDelete}
          />
        </div>
      </div>
    </div>
  );
};

TextField.propTypes = {
  translations: PropTypes.object.isRequired,
  id: PropTypes.number.isRequired,
  value: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  fieldTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  error: PropTypes.object,
  onDelete: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TextField;
